/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { ValidationUnion_UserFriendly_Fragment, ValidationUnion_InvalidFormat_Fragment } from '../../../../common/queries/queryTyping/validation-unions';
import { gql } from '@apollo/client';
import { ValidationUnionFragmentDoc } from '../../../../common/queries/queryTyping/validation-unions';
export type SmsEnrollmentResponseFragment = (
  { __typename?: 'SmsEnrollmentResult' }
  & Pick<Types.SmsEnrollmentResult, 'smsEnrollmentStatus' | 'successSummary' | 'successful'>
  & { errors: Array<Types.Maybe<(
    { __typename?: 'UserFriendly' }
    & ValidationUnion_UserFriendly_Fragment
  ) | (
    { __typename?: 'InvalidFormat' }
    & ValidationUnion_InvalidFormat_Fragment
  )>> }
);

export const SmsEnrollmentResponseFragmentDoc = gql`
    fragment SmsEnrollmentResponse on SmsEnrollmentResult {
  smsEnrollmentStatus
  successSummary
  successful
  errors {
    ...ValidationUnion
  }
}
    ${ValidationUnionFragmentDoc}`;